import { ReactNode } from 'react';

import { FormContextValues } from '@dreryk/react-common';

import { ReceptionServiceAdvancePaymentAmountInputField } from './components/advancePayment/fields/ReceptionServiceAdvancePaymentAmountInputField';
import { ReceptionServiceAdvancePaymentToggleField } from './components/advancePayment/fields/ReceptionServiceAdvancePaymentToggleField';
import {
   WithAdvancePayment,
   WithoutAdvancePayment,
} from './components/advancePayment/ReceptionServiceAdvancePayment.types';
import { ReceptionServicePractitionersInteractiveTable } from './components/practitioner/multiple/ReceptionServicePractitionersInteractiveTable';
import {
   WithMultiplePractitioners,
   WithSinglePractitioner,
} from './components/practitioner/receptionServicePractitioner.types';
import { ReceptionServicePractitionerTextView } from './components/practitioner/single/ReceptionServicePractitionerTextView';
import { ReceptionServiceFreeToggle } from './components/price/ReceptionServiceFreeToggle';
import { ReceptionServiceFreeText } from './components/price/ReceptionServiceFreeText';
import { AsFree, WithPrice, WithPriceRange } from './components/price/receptionServicePrice.types';
import { ReceptionServicePriceMoneyInput } from './components/price/ReceptionServicePriceMoneyInput';
import { ReceptionServicePriceMoneyRangeInput } from './components/price/ReceptionServicePriceMoneyRangeInput';
import { ReceptionServicePriceRangeCheckbox } from './components/price/ReceptionServicePriceRangeCheckbox';
import {
   ReceptionServiceVideoConsultationCheckbox,
   ReceptionServiceVideoConsultationValue,
} from './components/ReceptionServiceVideoConsultationCheckbox';
import {
   ReceptionServiceAdditionalInformationTextarea,
   ReceptionServiceAdditionalInformationValue,
} from './components/ReceptionServiceAdditionalInformationTextarea';
import {
   ReceptionServiceColorSelectorGroup,
   ReceptionServiceColorValue,
} from './components/ReceptionServiceColorSelectorGroup';
import {
   ReceptionServiceEstimatedDurationField,
   ReceptionServiceEstimatedDurationValue,
} from './components/ReceptionServiceEstimatedDurationField';
import { ReceptionServiceNameTextInput, ReceptionServiceNameValue } from './components/ReceptionServiceNameTextInput';
import {
   WithMultipleServiceLocations,
   WithSingleServiceLocation,
} from './components/serviceLocations/serviceLocations.types';
import { ServiceLocationsInteractiveTable } from './components/serviceLocations/multiple/ServiceLocationsInteractiveTable';
import { ServiceLocationsTextView } from './components/serviceLocations/single/ServiceLocationsTextView';
import { ReceptionServiceAdvancePaymentWarning } from './components/advancePayment/ReceptionServiceAdvancePaymentWarning';
import { StyledForm, StyledFourColumnsSpan, StyledTwoColumnsSpan } from './ReceptionServiceForm.styled';

export type ReceptionServiceFormBean = {
   name: ReceptionServiceNameValue | null;
   color: ReceptionServiceColorValue | null;
   additionalInformation: ReceptionServiceAdditionalInformationValue | null;
   estimatedDuration: ReceptionServiceEstimatedDurationValue;
   videoConsultation?: ReceptionServiceVideoConsultationValue;
} & (AsFree | WithPrice | WithPriceRange) &
   (WithMultipleServiceLocations | WithSingleServiceLocation) &
   (WithMultiplePractitioners | WithSinglePractitioner) &
   (AsFree | WithAdvancePayment | WithoutAdvancePayment);

export type ReceptionServiceFormController = FormContextValues<ReceptionServiceFormBean>;

type ReceptionServiceFormProps = {
   readonly children: ReactNode;
};

export const ReceptionServiceForm = (props: ReceptionServiceFormProps): JSX.Element => {
   return (
      <>
         <StyledForm noValidate autoComplete={'off'}>
            {props.children}
         </StyledForm>
      </>
   );
};

ReceptionServiceForm.TwoColumnsSpan = StyledTwoColumnsSpan;
ReceptionServiceForm.FourColumnsSpan = StyledFourColumnsSpan;
ReceptionServiceForm.NameTextInput = ReceptionServiceNameTextInput;
ReceptionServiceForm.ColorSelectorGroup = ReceptionServiceColorSelectorGroup;
ReceptionServiceForm.AdditionalInformationTextarea = ReceptionServiceAdditionalInformationTextarea;
ReceptionServiceForm.FreeToggle = ReceptionServiceFreeToggle;
ReceptionServiceForm.FreeText = ReceptionServiceFreeText;
ReceptionServiceForm.EstimatedDuration = ReceptionServiceEstimatedDurationField;
ReceptionServiceForm.AdvancePaymentToggle = ReceptionServiceAdvancePaymentToggleField;
ReceptionServiceForm.AdvancePaymentWarning = ReceptionServiceAdvancePaymentWarning;
ReceptionServiceForm.AdvancePaymentAmountMoneyInput = ReceptionServiceAdvancePaymentAmountInputField;
ReceptionServiceForm.PriceRangeCheckbox = ReceptionServicePriceRangeCheckbox;
ReceptionServiceForm.PriceMoneyInput = ReceptionServicePriceMoneyInput;
ReceptionServiceForm.PriceMoneyRangeInput = ReceptionServicePriceMoneyRangeInput;
ReceptionServiceForm.PractitionerTextView = ReceptionServicePractitionerTextView;
ReceptionServiceForm.PractitionersInteractiveTable = ReceptionServicePractitionersInteractiveTable;
ReceptionServiceForm.VideoConsultationCheckbox = ReceptionServiceVideoConsultationCheckbox;
ReceptionServiceForm.ServiceLocationTextView = ServiceLocationsTextView;
ReceptionServiceForm.ServiceLocationsInteractiveTable = ServiceLocationsInteractiveTable;
